export const clamp01 = (value: number) => Math.max(0, Math.min(1, value));
export function easeOutBack(value: number, strength = 1.7): number {
  const t = clamp01(value) - 1;
  return 1 + (strength + 1) * t * t * t + strength * t * t;
}
export function hpLoss(age: number, reduced = false) {
  return {
    flash: age >= 0 && age < 80,
    ghost:
      age < 0 || age >= 630 ? 0 : age < 330 ? 1 : 1 - ((age - 330) / 300) ** 2,
    shake:
      reduced || age < 0 || age >= 160
        ? 0
        : 3 * Math.sin(age * 0.15) * (1 - age / 160),
    squash:
      reduced || age < 0 || age >= 120 ? 0 : Math.sin((age / 120) * Math.PI),
  };
}
export function ammoScale(
  age: number,
  gaining: boolean,
  reduced = false,
): number {
  if (reduced) return gaining ? 1 : 0;
  if (!gaining) return 1 - clamp01(age / 140);
  return age >= 260
    ? 1
    : age < 160
      ? 1.25 * Math.sin((clamp01(age / 160) * Math.PI) / 2)
      : 1.25 - 0.25 * clamp01((age - 160) / 100);
}
export function damageMotion(age: number, reduced = false) {
  const p = clamp01(age / 600);
  return {
    visible: age >= 0 && age < 600,
    rise: reduced ? 0 : 30 * (1 - (1 - p) ** 3),
    scale: reduced
      ? 1
      : age < 90
        ? 0.6 + 0.7 * clamp01(age / 90)
        : age < 180
          ? 1.3 - 0.3 * clamp01((age - 90) / 90)
          : 1,
    alpha: age < 400 ? 1 : 1 - clamp01((age - 400) / 200),
  };
}
export function buttonScale(
  age: number,
  releasedAge: number | null,
  reduced = false,
) {
  if (reduced) return { x: 1, y: 1, lip: 0 };
  const amount =
    releasedAge === null
      ? clamp01(age / 70)
      : 1 - easeOutBack(releasedAge / 180, 2.5);
  return { x: 1 + 0.08 * amount, y: 1 - 0.12 * amount, lip: 3 * amount };
}
